module.exports = __webpack_public_path__ + "static/media/javascript.eabb4eaa.svg";